import { Link } from "react-router-dom";
import { ArrowUpRight, Instagram, MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import { Logo } from "./Logo";
import { waLink } from "@/lib/api";

export const Footer = ({ settings }) => {
  const ig = settings?.instagram || "sdesigner.ag";
  const num = settings?.whatsapp || "51980615838";
  return (
    <footer className="grain relative overflow-hidden bg-[#041214] pt-24 md:pt-36" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <p className="font-mono-x text-xs uppercase tracking-[0.22em] text-teal-300">Vamos criar juntos?</p>
          <a href={waLink(num)} target="_blank" rel="noreferrer" data-testid="footer-cta-whatsapp" className="group mt-6 flex items-end gap-4">
            <span className="font-display text-6xl font-semibold uppercase leading-[0.9] text-teal-50 transition-colors group-hover:text-[#2DD4BF] md:text-[9rem]">
              Fale <span className="font-serif-i normal-case">com a gente</span>
            </span>
            <ArrowUpRight className="mb-3 h-10 w-10 shrink-0 text-[#2DD4BF] transition-transform group-hover:-translate-y-2 group-hover:translate-x-2 md:h-20 md:w-20" />
          </a>
        </Reveal>
        <div className="mt-20 grid gap-10 border-t border-[#163D43] py-10 md:grid-cols-3">
          <Logo />
          <div className="flex flex-col gap-3 text-teal-100">
            <a href={waLink(num)} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:text-[#2DD4BF]" data-testid="footer-whatsapp"><MessageCircle className="h-4 w-4" /> WhatsApp ({num.slice(0, 2)}) {num.slice(2, 7)}-{num.slice(7)}</a>
            <a href={`https://instagram.com/${ig}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:text-[#2DD4BF]" data-testid="footer-instagram"><Instagram className="h-4 w-4" /> @{ig}</a>
          </div>
          <div className="flex flex-col gap-2 text-sm text-teal-300 md:items-end">
            <span>© {new Date().getFullYear()} Agência S'Designer</span>
            <Link to="/acompanhar" className="text-[#2DD4BF] hover:text-white" data-testid="footer-track-link">Acompanhar meu pedido</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
